import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import PgRoot from "./components/pages/PgRoot";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ERoute } from "./enums/ERoute";
import "./i18n/config";

ReactDOM.render(
  <React.StrictMode>
    <Router basename={process.env.REACT_APP_ROUTER_BASE || ''}>
      <Routes>
        <Route path={ERoute.ROOT} element={<PgRoot />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
